import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import IntegerInput from "commons/ui/input/IntegerInput";
import SwitchInput from "commons/ui/input/SwitchInput";
import Paper from "commons/ui/Paper";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";

import { FormCatalogHook } from "hooks/form/useCatalogForm";

import { DesktopOrMobile } from "types/enums";

type PropsType = {
    formCatalogHook: FormCatalogHook;
};

function CatalogForm({ formCatalogHook }: PropsType) {
    const { setDesktopMobileImage, setSingleFile, formHook } = formCatalogHook;

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-3"}>
                            <IntegerInput
                                label={"Ordinamento"}
                                path={"graphical_order"}
                                value={form.graphical_order}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-3"}>
                            <SwitchInput
                                label="Area pubblica"
                                checked={form.front_visible}
                                setValue={setValue}
                                path={"front_visible"}
                                alignedToForm
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-3"}>
                            <SwitchInput
                                label="Area riservata"
                                checked={form.reserved_area_visible}
                                setValue={setValue}
                                path={"reserved_area_visible"}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Catalogo</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("it")}
                                label={"Titolo italiano"}
                                setValue={setValue}
                                value={form.text.it.title}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("en")}
                                label={"Titolo inglese"}
                                setValue={setValue}
                                value={form.text.en.title}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"File PDF"}
                                setFile={(file) => setSingleFile(file, "file")}
                                file={form.file}
                                accept={".pdf"}
                                errors={checkErrorVisibility("file")}
                                info={
                                    <div className={"extensions-proporsion-info file"}>
                                        <GridItem>
                                            Carica il tuo catalogo in{" "}
                                            <div className={"strong-text"}>PDF</div>
                                        </GridItem>
                                        <GridItem>
                                            Peso massimo consigliato:{" "}
                                            <div className={"strong-text"}>20MB</div>
                                        </GridItem>
                                    </div>
                                }
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Copertina</h2>
                        </GridItem>
                    </GridRow>

                    <ExtensionsProporsionInfo
                        desktopText={"Desktop: 600x600px (max 100KB)"}
                        mobileText={"Mobile: 400x400px (max 80KB)"}
                        proportion={"quadrata"}
                    />

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Desktop"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.desktop)
                                }
                                file={form.cover_img.desktop}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.desktop")}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Mobile"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.mobile)
                                }
                                file={form.cover_img.mobile}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.mobile")}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default CatalogForm;
